import { render, staticRenderFns } from "./Header_Comp.vue?vue&type=template&id=64c566dc&scoped=true&"
import script from "./Header_Comp.vue?vue&type=script&lang=js&"
export * from "./Header_Comp.vue?vue&type=script&lang=js&"
import style0 from "./Header_Comp.vue?vue&type=style&index=0&id=64c566dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c566dc",
  null
  
)

export default component.exports